// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512170934/js/" + chunkId + "." + {"44":"1ae1538a","225":"83e177e4","481":"ab4518c8","486":"e347b57a","770":"32f9bb79"}[chunkId] + ".0.9341319545417486.chunk.js";
};